import IframeModalContainer from './IframeModal'

export default IframeModalContainer
